// removed by extract-text-webpack-plugin
module.exports = {"tabs":"ProductTabs-module-tabs-mj0kL","tabs-links":"ProductTabs-module-tabs-links-215CS","tabsLinks":"ProductTabs-module-tabs-links-215CS","item":"ProductTabs-module-item-hH-i5"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Product/components/ProductTabs/ProductTabs.module.scss
// module id = 1270
// module chunks = 0